// Mock data for Montreon Car Rental

export const translations = {
  ro: {
    nav: {
      fleet: "Flotă",
      pricing: "Prețuri",
      booking: "Rezervare",
      contact: "Contact"
    },
    hero: {
      title: "Închirieri Auto în Brașov",
      subtitle: "de la 30EUR/zi - fără depozit",
      description: "Autoturisme economy & premium cu kilometraj nelimitat și livrare gratuită la adresă în Brașov sau la Aeroport Ghimbav (GHV).",
      cta: "Rezervă Online în 2 Minute",
      viewFleet: "Vezi Flota",
      callUs: "Sună Acum",
      feature1Title: "Livrare Gratuită",
      feature1Desc: "Brașov & Aeroport",
      feature2Title: "Suport 24/7",
      feature2Desc: "Mereu disponibili",
      feature3Title: "Kilometraj Nelimitat",
      feature3Desc: "Fără restricții"
    },
    fleet: {
      title: "Flota Noastră",
      subtitle: "Standard și premium - alegerea ta",
      bookNow: "Rezervă",
      viewDetails: "Detalii",
      passengers: "pasageri",
      luggage: "bagaje",
      transmission: "Transmisie",
      fuel: "Combustibil"
    },
    pricing: {
      title: "Calculator Prețuri",
      subtitle: "Obține o ofertă instantanee",
      selectCar: "Selectează Mașina",
      pickupDate: "Data Ridicare",
      returnDate: "Data Returnare",
      days: "zile",
      pricePerDay: "Preț pe zi",
      total: "Total",
      calculate: "Calculează"
    },
    booking: {
      title: "Rezervă Mașina Ta",
      fullName: "Nume Complet",
      email: "Email",
      phone: "Telefon",
      pickupDate: "Data Ridicare",
      returnDate: "Data Returnare",
      pickupLocation: "Locație Ridicare",
      dropoffLocation: "Locație Returnare",
      pickupTime: "Ora Ridicare",
      dropoffTime: "Ora Returnare",
      selectCar: "Selectează Mașina",
      insurance: "Pachet Asigurare",
      paymentMethod: "Metodă de Plată",
      extraOptions: "Opțiuni Suplimentare",
      submit: "Continuă la Plată",
      submitCash: "Confirmă Rezervarea",
      submitBank: "Confirmă Rezervarea",
      submitRequest: "Trimite Cererea de Rezervare",
      success: "Vă mulțumim pentru interesul arătat serviciilor noastre. Echipa noastră vă va contacta cât mai curând posibil cu detalii suplimentare despre rezervare și plată.",
      error: "Te rugăm să completezi toate câmpurile.",
      priceBreakdown: "Detalii Preț",
      carRental: "Închiriere Mașină",
      insuranceFee: "Asigurare",
      locationFees: "Taxe Locație",
      extraOptionsFees: "Opțiuni Extra",
      days: "zile",
      total: "Total",
      deposit: "Depozit Necesar"
    },
    contact: {
      title: "Contactează-ne",
      subtitle: "Suntem aici pentru tine 24/7",
      address: "Adresă",
      addressValue: "Str. Avram Iancu nr. 56, ap. 2, Brașov",
      phone: "Telefon",
      phoneValue: "+40 726 375 166",
      email: "Email",
      hours: "Program",
      hoursValue: "24/7 Disponibil"
    },
    advantages: {
      title: "De Ce Să Ne Alegi",
      subtitle: "Servicii complete pentru călătoria ta",
      advantage1: "Livrare gratuită la adresă în Brașov",
      advantage2: "Preluare gratuită de la Aeroportul Internațional Brașov",
      advantage3: "Fără costuri pentru curățare auto",
      advantage4: "Fără taxe ascunse"
    },
    footer: {
      tagline: "Închirieri auto în Brașov - standard și premium",
      rights: "Toate drepturile rezervate."
    }
  },
  en: {
    nav: {
      fleet: "Fleet",
      pricing: "Pricing",
      booking: "Booking",
      contact: "Contact"
    },
    hero: {
      title: "Car Rentals in Brașov",
      subtitle: "from 30EUR/day - no deposit",
      description: "Economy & premium vehicles with unlimited mileage and free delivery to your address in Brașov or Ghimbav Airport (GHV).",
      cta: "Book Online in 2 Minutes",
      viewFleet: "View Fleet",
      callUs: "Call Now",
      feature1Title: "Free Delivery",
      feature1Desc: "Brașov & Airport",
      feature2Title: "24/7 Support",
      feature2Desc: "Always available",
      feature3Title: "Unlimited Mileage",
      feature3Desc: "No restrictions"
    },
    fleet: {
      title: "Our Fleet",
      subtitle: "Standard and premium - your choice",
      bookNow: "Book Now",
      viewDetails: "Details",
      passengers: "passengers",
      luggage: "luggage",
      transmission: "Transmission",
      fuel: "Fuel"
    },
    pricing: {
      title: "Pricing Calculator",
      subtitle: "Get an instant quote",
      selectCar: "Select Car",
      pickupDate: "Pick-up Date",
      returnDate: "Return Date",
      days: "days",
      pricePerDay: "Price per day",
      total: "Total",
      calculate: "Calculate"
    },
    booking: {
      title: "Book Your Car",
      fullName: "Full Name",
      email: "Email",
      phone: "Phone",
      pickupDate: "Pick-up Date",
      returnDate: "Return Date",
      pickupLocation: "Pick-up Location",
      dropoffLocation: "Drop-off Location",
      pickupTime: "Pick-up Time",
      dropoffTime: "Drop-off Time",
      selectCar: "Select Car",
      insurance: "Insurance Package",
      paymentMethod: "Payment Method",
      extraOptions: "Extra Options",
      submit: "Proceed to Payment",
      submitCash: "Confirm Booking",
      submitBank: "Confirm Booking",
      submitRequest: "Submit Booking Request",
      success: "Thank you for your interest shown in our services. Our team will reach out as soon as possible with further booking and payment details.",
      error: "Please fill in all fields.",
      priceBreakdown: "Price Breakdown",
      carRental: "Car Rental",
      insuranceFee: "Insurance",
      locationFees: "Location Fees",
      extraOptionsFees: "Extra Options",
      days: "days",
      total: "Total",
      deposit: "Deposit Required"
    },
    contact: {
      title: "Contact Us",
      subtitle: "We're here for you 24/7",
      address: "Address",
      addressValue: "Str. Avram Iancu nr. 56, ap. 2, Brașov",
      phone: "Phone",
      phoneValue: "+40 726 375 166",
      email: "Email",
      hours: "Hours",
      hoursValue: "24/7 Available"
    },
    advantages: {
      title: "Why Choose Us",
      subtitle: "Complete services for your journey",
      advantage1: "Free delivery to address in Brașov",
      advantage2: "Free pick-up from Brașov International Airport",
      advantage3: "No charges for car cleaning",
      advantage4: "No hidden fees"
    },
    footer: {
      tagline: "Car rentals in Brașov - standard and premium",
      rights: "All rights reserved."
    }
  }
};

export const insurancePackages = {
  none: {
    id: 'none',
    nameEn: 'Without Insurance',
    nameRo: 'Fără Asigurare',
    descriptionEn: 'Refundable guarantee deposit required',
    descriptionRo: 'Depozit de garanție rambursabil necesar',
    pricePerDay: 0
  },
  limited: {
    id: 'limited',
    nameEn: 'Limited Coverage',
    nameRo: 'Acoperire Limitată',
    descriptionEn: 'No tyres, windows, theft protection',
    descriptionRo: 'Fără anvelope, geamuri, protecție furt',
    pricePerDay: 15
  },
  premium: {
    id: 'premium',
    nameEn: 'Full Protection',
    nameRo: 'Protecție Completă',
    descriptionEn: 'Full insurance and coverage, no deposit',
    descriptionRo: 'Asigurare și acoperire completă, fără depozit',
    pricePerDay: 20
  }
};

export const pickupLocations = [
  { id: 'coresi', nameEn: 'Brașov: Coresi Shopping Center', nameRo: 'Brașov: Coresi Shopping Center', price: 0 },
  { id: 'brasov-address', nameEn: 'Brașov: Address', nameRo: 'Brașov: Adresă', price: 0 },
  { id: 'brasov-airport', nameEn: 'Brașov International Airport (GHV)', nameRo: 'Aeroportul Internațional Brașov (GHV)', price: 0 },
  { id: 'predeal', nameEn: 'Predeal', nameRo: 'Predeal', price: 30 },
  { id: 'poiana', nameEn: 'Poiana Brașov', nameRo: 'Poiana Brașov', price: 30 },
  { id: 'bran', nameEn: 'Bran', nameRo: 'Bran', price: 50 },
  { id: 'sibiu-airport', nameEn: 'Sibiu International Airport', nameRo: 'Aeroportul Internațional Sibiu', price: 120 },
  { id: 'otopeni-airport', nameEn: 'Otopeni International Airport', nameRo: 'Aeroportul Internațional Otopeni', price: 120 },
  { id: 'cluj', nameEn: 'Cluj-Napoca', nameRo: 'Cluj-Napoca', price: 200 }
];

export const extraOptions = [
  { 
    id: 'child-seat', 
    nameEn: 'Child Seat (0-5 years)', 
    nameRo: 'Scaun Copii (0-5 ani)', 
    price: 15,
    descriptionEn: 'One-time fee',
    descriptionRo: 'Plată unică'
  },
  { 
    id: 'extra-driver', 
    nameEn: 'Additional Driver (First Free)', 
    nameRo: 'Șofer Suplimentar (Primul Gratuit)', 
    price: 0,
    descriptionEn: 'First additional driver included free',
    descriptionRo: 'Primul șofer suplimentar inclus gratuit'
  },
  { 
    id: 'traveling-abroad', 
    nameEn: 'Traveling Abroad', 
    nameRo: 'Călătorie în Străinătate', 
    price: 120,
    descriptionEn: 'One-time fee',
    descriptionRo: 'Plată unică'
  }
];

export const paymentMethods = {
  stripe: {
    id: 'stripe',
    nameEn: 'Online Card Payment',
    nameRo: 'Plată Online cu Card',
    descriptionEn: 'Secure payment via Stripe',
    descriptionRo: 'Plată securizată prin Stripe'
  },
  bank: {
    id: 'bank',
    nameEn: 'Bank Transfer',
    nameRo: 'Transfer Bancar',
    descriptionEn: 'Transfer to our bank account',
    descriptionRo: 'Transfer către contul nostru bancar'
  }
};

export const cars = [
  {
    id: 1,
    name: "Volkswagen Passat",
    category: "Business Wagon",
    image: "/images/passat.webp",
    pricePerDay: 45,
    deposits: {
      none: 400,
      limited: 200,
      premium: 0
    },
    insurancePricing: {
      none: 0,
      limited: 15,
      premium: 20
    },
    passengers: 5,
    luggage: 4,
    transmission: "Automatic",
    fuel: "Diesel",
    features: ["Cruise Control", "Navigation", "Bluetooth", "Air Conditioning"]
  },
  {
    id: 3,
    name: "Mercedes E200",
    category: "Business Sedan",
    image: "/images/e200.webp",
    pricePerDay: 35,
    deposits: {
      none: 400,
      limited: 200,
      premium: 0
    },
    insurancePricing: {
      none: 0,
      limited: 15,
      premium: 20
    },
    passengers: 5,
    luggage: 3,
    transmission: "Manual",
    fuel: "Petrol",
    features: ["Navigation", "Bluetooth", "Air Conditioning", "Leather Seats"]
  },
  {
    id: 2,
    name: "Skoda Superb",
    category: "Executive Wagon",
    image: "/images/superb.webp",
    pricePerDay: 45,
    deposits: {
      none: 400,
      limited: 200,
      premium: 0
    },
    insurancePricing: {
      none: 0,
      limited: 15,
      premium: 20
    },
    passengers: 5,
    luggage: 4,
    transmission: "Automatic",
    fuel: "Diesel",
    features: ["Leather Seats", "Panoramic Roof", "Premium Sound", "Heated Seats"]
  },
  {
    id: 4,
    name: "Mercedes E300de",
    category: "Luxury Hybrid",
    image: "/images/e300de.webp",
    pricePerDay: 80,
    deposits: {
      none: 600,
      limited: 300,
      premium: 0
    },
    insurancePricing: {
      none: 0,
      limited: 15,
      premium: 20
    },
    passengers: 5,
    luggage: 4,
    transmission: "Automatic",
    fuel: "Hybrid",
    features: ["Latest Model", "Hybrid Technology", "Premium Comfort", "Advanced Safety"]
  },
  {
    id: 5,
    name: "Tesla Model 3",
    category: "Electric Premium",
    image: "/images/tesla.webp",
    pricePerDay: 80,
    deposits: {
      none: 600,
      limited: 300,
      premium: 0
    },
    insurancePricing: {
      none: 0,
      limited: 15,
      premium: 20
    },
    passengers: 5,
    luggage: 3,
    transmission: "Automatic",
    fuel: "Electric",
    features: ["Autopilot", "Premium Interior", "Large Display", "Supercharging"]
  },
  {
    id: 6,
    name: "Mercedes Vito",
    category: "Premium Van",
    image: "/images/vito.webp",
    pricePerDay: 80,
    deposits: {
      none: 600,
      limited: 300,
      premium: 0
    },
    insurancePricing: {
      none: 0,
      limited: 15,
      premium: 20
    },
    passengers: 8,
    luggage: 6,
    transmission: "Automatic",
    fuel: "Diesel",
    features: ["Spacious Interior", "Climate Control", "Power Sliding Doors", "Comfort Seats"]
  }
];
